import React from "react";

export const getImg = (url, classes, alt = "Recurso no encontrado") => (
  <img src={url} alt={alt} className={classes} />
);

export const appVersion = () => {
  const pjson = require("./../package.json");
  const currentVersion = `v${pjson.version}`;
  return currentVersion;
};
